import EfSpec from '@elem/ui/ef-spec';
import EfTitle from '@elem/ui/ef-title';
import EfSwiperCardBundle, { EfSwiperCardBundleProps } from '@elem/ui/ef-swiper-card-bundle';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { dataLocal } from './configs';
import { useState, useEffect } from 'react';
import { getSolarRecommand } from '@/service/solar-calculator';
import FootTC from '../../compsJp/FootTC';

export default function Bundles({ callbackCart }: any) {
    const { t } = useLang('theProduct.Bundles');
    const { locale } = useRouter();
    const data = dataLocal[locale];
    const { data1, data2, data3 } = data;

    const [data1State, setData1State] = useState<EfSwiperCardBundleProps[]>(data1);
    const [data2State, setData2State] = useState<EfSwiperCardBundleProps[]>(data2);
    const [data3State, setData3State] = useState<EfSwiperCardBundleProps[]>(data3);

    const getAsynItem = async (item: EfSwiperCardBundleProps) => {
        const { productId, variantId } = item.info;
        return await new Promise(async (resolve, reject) => {
            try {
                const res = await getSolarRecommand({ productId, variantId }, locale);
                if (res?.code === '0') {
                    item.info.discountPrice = res?.data?.price ?? 0;
                    item.info.originalPrice = res?.data?.compareAtPrice ?? res?.data?.price ?? 0;
                    item.info.inventory = res?.data?.inventoryQuantity ?? 0;
                    // item.inventory = 1;
                    // item.info.link_buy = `https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`;
                    if (res?.data?.img) {
                        item.items[0].img = res?.data?.img;
                    }
                    item.info.img = item.items[0].img;
                    if (res?.data?.productTitle || res?.data?.skuTitle) {
                        item.info.title = res?.data?.productTitle || res?.data?.skuTitle;
                    }
                    return resolve(res);
                } else {
                    console.error(res?.message);
                    return reject(res?.message);
                }
            } catch (e) {
                console.error(e);
                return reject(e);
            }
        });
    };

    useEffect(() => {
        [data1State, data2State, data3State].map((data: EfSwiperCardBundleProps, k: number) => {
            const tempData = JSON.parse(JSON.stringify(data));
            const dataPromises = tempData?.map((item: EfSwiperCardBundleProps) => getAsynItem(item));
            Promise.all(dataPromises)
                .then(() => {
                    switch (k) {
                        case 0:
                            setData1State(tempData);
                            break;
                        case 1:
                            setData2State(tempData);
                            break;
                        case 2:
                            setData3State(tempData);
                            break;
                        default:
                            break;
                    }
                })
                .catch((e) => {
                    console.error(e);
                });
        });
    }, []);

    return (
        <div className={styles.bundles}>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('title1')}</EfTitle>
            <ul className="items">
                {data1State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} callbackCart={callbackCart} list_name={t('title1')} />
                ))}
            </ul>
            <EfSpec className="spec" />
            <EfTitle hasAnimation={false}>{t('title2')}</EfTitle>
            <ul className="items">
                {data2State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} callbackCart={callbackCart} list_name={t('title2')} />
                ))}
            </ul>
            <ul className="lists">
                {data3State?.map((item: EfSwiperCardBundleProps, k: number) => (
                    <EfSwiperCardBundle {...item} key={k} callbackCart={callbackCart} list_name={t('title2')} />
                ))}
            </ul>
            <EfSpec className="spec" />
            <FootTC />
        </div>
    );
}
